import * as yup from 'yup'
import { InferType } from 'yup'

import { POSTAL_CODE_REGEX } from '@/constants'
import { TTranslationFunction } from '@/types'

import { urlSchema } from '../fieldSchemas'

export const STREET_MAX_LENGTH = 200
export const CITY_MAX_LENGTH = 200
export const STATE_MAX_LENGTH = 100
export const COUNTRY_MAX_LENGTH = 50
export const POSTAL_CODE_MIN_LENGTH = 2
export const POSTAL_CODE_MAX_LENGTH = 15

export const getFullAddressSchema = (t: TTranslationFunction) =>
	yup
		.object({
			street: yup.string().max(STREET_MAX_LENGTH),
			postalCode: yup
				.string()
				.trim()
				.test(
					'postal-code-validation',
					t('ui__field_validation_errors__postal_code__end_and_start'),
					function (value) {
						if (!value || !value.trim()) return true
						const lengthValid =
							value.length >= POSTAL_CODE_MIN_LENGTH &&
							value.length <= POSTAL_CODE_MAX_LENGTH
						const regexValid = POSTAL_CODE_REGEX.test(value)
						if (!lengthValid) {
							return this.createError({
								message: t('ui__field_validation_errors__generic__min_max', {
									min: POSTAL_CODE_MIN_LENGTH,
									max: POSTAL_CODE_MAX_LENGTH,
								}),
							})
						}
						return regexValid
					},
				),
			city: yup.string().max(CITY_MAX_LENGTH),
			state: yup.string().max(STATE_MAX_LENGTH),
			country: yup.string().max(COUNTRY_MAX_LENGTH),
		})
		.required()

export const getUrlAddressSchema = (t: TTranslationFunction) =>
	yup
		.object({
			url: urlSchema(t, { required: false }),
		})
		.required()

export const getAddressSchema = (t: TTranslationFunction) =>
	yup.object({
		address: yup.lazy((value) =>
			typeof value === 'object' &&
			value !== null &&
			typeof value.url === 'string' &&
			value.url.trim() !== ''
				? getUrlAddressSchema(t)
				: getFullAddressSchema(t),
		),
	})

export type TFullAddress = InferType<ReturnType<typeof getFullAddressSchema>>
export type TUrlAddress = InferType<ReturnType<typeof getUrlAddressSchema>>

export type TAddress = TFullAddress & TUrlAddress
export type TAddressFormFields = {
	address: TAddress
}

export type TAddressType = 'manual' | 'url'

export type TAddressFields = { address: TAddress }
